import { useLayoutEffect, useRef, useState } from "react";

// Scales its single line/text content down to fit the parent box (width + height).
// Used for the kiosk church-name tile so long names never get clipped.
export function FitText({ children, max = 64, min = 10, className = "", style = {} }) {
  const boxRef = useRef(null);
  const txtRef = useRef(null);
  const [fontSize, setFontSize] = useState(max);

  useLayoutEffect(() => {
    const box = boxRef.current;
    const txt = txtRef.current;
    if (!box || !txt) return;

    const fit = () => {
      let lo = min;
      let hi = max;
      let best = min;
      while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        txt.style.fontSize = `${mid}px`;
        if (txt.scrollWidth <= box.clientWidth && txt.scrollHeight <= box.clientHeight) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      txt.style.fontSize = `${best}px`;
      setFontSize(best);
    };

    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(box);
    return () => ro.disconnect();
  }, [children, max, min]);

  return (
    <div ref={boxRef} className={`w-full h-full overflow-hidden flex flex-col justify-center ${className}`}>
      <div ref={txtRef} style={{ ...style, fontSize, lineHeight: 1.05, whiteSpace: "normal" }}>
        {children}
      </div>
    </div>
  );
}
